import { LOGIN_FAIL, LOGIN_OK, LOGOUT } from './actionTypes';

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_OK:
      return {
        error: '',
        loggedIn: true
      };
    case LOGIN_FAIL:
      return {
        error: 'We could not find a matching email and password.',
        loggedIn: false
      };
    case LOGOUT:
      return {
        error: '',
        loggedIn: false
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/loginReducer.js